import { Component, Input } from '@angular/core'
import { Footnote } from 'src/app/models/footnote.model'
import { NavArr, Returns } from 'src/app/models/performance-response.model'

@Component({
  selector: 'performance-annually',
  templateUrl: './performance-annually.component.html',
  styleUrls: ['./performance-annually.component.scss'],
})
export class PerformanceAnnuallyComponent {
  @Input() data: Returns
  @Input() profileData: any
  @Input() benchmarkFootNote: Footnote
  @Input() marketPriceFootNote: Footnote
  tableData: NavArr

  ngOnChanges() {
    if (
      this.data !== null &&
      this.data['annualReturns'] !== undefined &&
      this.data['annualReturns'].length > 0
    ) {
      this.tableData = this.data['annualReturns'][0].item
    }
  }
}
